import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./useAuth";

/**
 * Route guard for protected routes. While the /auth/me query is in flight we
 * render nothing (avoids a login flash); on 401 (or any auth failure) we
 * redirect to /login. {local: true} is treated as authenticated.
 */
export function RequireAuth() {
  const { isLoading, isAuthenticated, isUnauthenticated } = useAuth();

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    return <Outlet />;
  }

  if (isUnauthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Any other error state: fail closed to login.
  return <Navigate to="/login" replace />;
}
